import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check if user is authenticated
  const userId = localStorage.getItem('userId');
  
  // If not authenticated, redirect to login
  if (!userId) {
    console.log('🔒 User not authenticated, redirecting to login');
    return <Navigate to="/" replace />;
  }
  
  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;